(() => {
  const instances = new Map();
  const initialize = (root) => {
    if (instances.has(root)) return;
    const details = Array.from(root.querySelectorAll('.sbe-goal'));
    if (!details.length) return;
    const media = window.matchMedia('(min-width: 990px)');
    const controller = new AbortController();
    let frame = 0;
    const ensureOpen = () => {
      if (media.matches && !details.some(item => item.open)) {
        (details.find(item => item.hasAttribute('data-default')) || details[0]).open = true;
      }
    };
    const measure = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const panel = details.find(item => item.open)?.querySelector('.sbe-goal__panel');
        if (media.matches && panel) root.style.setProperty('--sb-panel-height', Math.ceil(panel.getBoundingClientRect().height) + 'px');
        else root.style.removeProperty('--sb-panel-height');
      });
    };
    const refresh = () => { ensureOpen(); measure(); };
    details.forEach(item => {
      item.querySelector('summary').addEventListener('click', event => {
        if (media.matches && item.open) event.preventDefault();
      }, { signal: controller.signal });
      item.addEventListener('toggle', () => {
        if (item.open) details.forEach(other => { if (other !== item && other.open) other.open = false; });
        measure();
      }, { signal: controller.signal });
    });
    const observer = typeof ResizeObserver === 'function' ? new ResizeObserver(measure) : null;
    details.forEach(item => observer?.observe(item.querySelector('.sbe-goal__panel')));
    media.addEventListener('change', refresh);
    root.classList.add('is-enhanced');
    refresh();
    instances.set(root, () => {
      controller.abort();
      observer?.disconnect();
      media.removeEventListener('change', refresh);
      cancelAnimationFrame(frame);
      root.classList.remove('is-enhanced');
      root.style.removeProperty('--sb-panel-height');
    });
  };
  const scan = (scope) => {
    if (scope.matches?.('[data-sb-goals]')) initialize(scope);
    scope.querySelectorAll('[data-sb-goals]').forEach(initialize);
  };
  scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((dispose, root) => {
      if (event.target === root || event.target.contains(root)) { dispose(); instances.delete(root); }
    });
  });
  document.addEventListener('shopify:block:select', event => {
    const item = event.target.closest('.sbe-goal');
    if (item) item.open = true;
  });
})();
